import { EbpCase } from '../schemas';

// RTW outcome capture (PPL-2776).
//
// Organizations with `caseWorkflows.rtwOutcomeTracking` (L&G GIP, Aviva) report
// RTW outcomes in client MI, so both outcome answers must be captured before
// a nurse can discharge the member. The rule lives here because the UI (to
// disable the Discharge button) and the discharge API (to reject a bypass)
// must agree on what "captured" means.

// Bullet phrasing of the requirement — one entry of the disabled Discharge
// button's "available when:" list.
export const rtwOutcomesRequirement = "RTW outcomes under 'Forms' are captured";

// Returned by the discharge API when the requirement is bypassed.
export const rtwOutcomesRequiredMessage = `Discharge is not available until ${rtwOutcomesRequirement}`;

// Shown under each outcome field that is still unanswered.
export const rtwOutcomeRequiredFieldMessage =
  'Required before the member can be discharged';

// "Somewhat" is stored as null, so only an absent field counts as unanswered.
export const isImprovedKeyChallengeCaptured = (
  improvedKeyChallenge: EbpCase['improvedKeyChallenge'],
) => improvedKeyChallenge !== undefined;

// Return to work is written as a whole answer (returned + rationale) or not
// at all — an unanswered one is null or absent.
export const isReturnedToWorkCaptured = (
  returnedToWork: EbpCase['returnedToWork'],
) => !!returnedToWork;

export const hasRtwOutcomesCaptured = (
  ebpCase: Pick<EbpCase, 'improvedKeyChallenge' | 'returnedToWork'>,
) =>
  isImprovedKeyChallengeCaptured(ebpCase.improvedKeyChallenge) &&
  isReturnedToWorkCaptured(ebpCase.returnedToWork);
